import { Text } from "@react-three/drei";
import { useMemo } from "react";
import { darkenColor } from "../../../utils/visualizerUtils";

const Zone = ({ obj, transparent, opacity, areaLocationsToHighlight = {} }) => {
  const [w] = obj.size;
  const [width, , depth] = obj.size;
  const textSize = Math.min(width, depth) * 0.15;

  const { areaLocations, primaryColor } = areaLocationsToHighlight;

  const isHighlighted = areaLocations?.includes(obj.code);
  const baseColor = isHighlighted ? primaryColor : obj.color;
  const sideColor = darkenColor(baseColor, 0.3);

  // 3D thickness
  const height = 0.15;
  const sideH = 0.14;
  const sideT = 0.02;

  const sideMeshes = useMemo(
    () => (
      <group>
        {/* Front */}
        <mesh >
          <boxGeometry args={[width, sideH, sideT]} />
          <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.7} />
        </mesh>

        {/* Back */}
        <mesh   >       <boxGeometry args={[width, sideH, sideT]} />
          <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.7} />
        </mesh>

        {/* Left */}
        <mesh      >    <boxGeometry args={[sideT, sideH, depth]} />
          <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.7} />
        </mesh>

        {/* Right */}
        <mesh      >    <boxGeometry args={[sideT, sideH, depth]} />
          <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.7} />
        </mesh>
      </group>
    ),
    [width, depth, sideH, sideT, sideColor]
  );



  return (
    <group  rotation={[0, obj.rotationY || 0, 0]}>
      {/* MAIN 3D PLATFORM */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]}>
        <boxGeometry args={[width, depth, height]} />
        <meshStandardMaterial color={baseColor} transparent={transparent} opacity={opacity || 1} metalness={0.2} roughness={0.7} />
      </mesh>

      {/* SIDES — darker tone */}
      {sideMeshes}

      {/* SOFT OUTER BORDER (replaces black line) */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, height + 0.001, 0]} renderOrder={1}>
        <planeGeometry args={[width + 0.05, depth + 0.05]} />
        <meshBasicMaterial color={obj.color} opacity={1} depthWrite={false} />
      </mesh>

      {/* LABEL */}
      <Text
        position={[0, height + 0.05, 0]}
        rotation={[-Math.PI / 2, 0, 0]}
        fontSize={textSize}
        color="black"
        maxWidth={width * 0.9}
        anchorX="center"
        anchorY="middle"
        overflowWrap="break-word"
        whiteSpace="normal"
      >
        {obj.name}
      </Text>
    </group>
  );
};

export default Zone;
